import React from 'react';
import Login from './Login';

const StaffLogin = () => {
  return <Login variant="staff" />;
};

export default StaffLogin;

